// tab
$('.ui.sticky').sticky({
  context: 'main',
  silent: true,
});
$('.menu.category .item').tab();

// 選択中のタブを中央にする
$(function(){
  var tab = $('.menu.category .item.active');
  if (tab[0]) {
    var xpos = tab.offset().left;
    var scroll = $('.tabular.menu').scrollLeft();
    var move = window.innerWidth*0.5 - xpos - tab.outerWidth()*0.5;
    $('.tabular.menu').animate({scrollLeft: scroll - move}, 0);
  }
});

// modal
// $('.ui.modal.gmenu').modal('attach events', '.gmenu.open.button', 'show');

// search button
$('#searchButton').on('click', function(){
  if ($('#keywordSearch input[name="s"]').val().length > 0) {
    $('#keywordSearch').submit();
  }
});

// サブカテゴリ絞り込み用プルダウン
// Aタグの挙動を無効にしてonChangeでページ遷移する
$('#category-filter-button').dropdown({
  direction: 'upward',
  onChange: function(text){
    location.href = $(text).attr("href");
  }
});
$(function(){
  $('#category-filter-button a').click(function(event){
    event.preventDefault();
  });
});

// sidebar
$('.ui.sidebar')
.sidebar('attach events', '.toggle_sidebar.item')
;

// lazy load images
$('.image img').visibility({
  type       : 'image',
  transition : 'fade in',
  duration   : 1000
});